import { Outlet } from "react-router-dom";
import MarlinThemeProvider from "./MarlinThemeProvider";

export default function BasicRoot() {
  return (
    <MarlinThemeProvider>
      <Outlet />
    </MarlinThemeProvider>
  );
}
